export const DASHBOARD_TYPES = {
    DASHBOARD_GET_CARD_SETTINGS :"DASHBOARD_GET_CARD_SETTINGS",
    DASHBOARD_SAVE_CARD_SETTINGS : "DASHBOARD_SAVE_CARD_SETTINGS",
    DASHBOARD_UPDATE_CARD_SETTINGS :"DASHBOARD_UPDATE_CARD_SETTINGS",
    OPEN_DASHBOARD_MANAGE_CARDS :"OPEN_DASHBOARD_MANAGE_CARDS",
    GET_STAFF_DASHBOARD_CARD_MY_TIME: "GET_STAFF_DASHBOARD_CARD_MY_TIME",
    SAVE_STAFF_DASHBOARD_CARD_MY_TIME: "SAVE_STAFF_DASHBOARD_CARD_MY_TIME"
}


